import { singleOrGrouped } from '../types';
import { SinglePropertyBatchPreparerAccordion } from './single';

export const PropertyBatchPreparerAccordion = singleOrGrouped(
  SinglePropertyBatchPreparerAccordion,
  () => {
    throw new Error('GroupedPropertyBatchPreparerAccordion is not implemented');
  }
);
